import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 70EFA358-6CE3-4CC1-9F46-6283D491F2E2
 * name forest
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/forest.svg
 * tags
 * - Nature 
 * - Agriculture 
 * - Places 
 */
export const ForestIcon = createSvgIcon(<><path d="M16 12L9 2L2 12H3.86L0 18H7V22H11V18H18L14.14 12H16M20.14 12H22L15 2L12.61 5.41L17.92 13H15.97L19.19 18H24L20.14 12M13 19H17V22H13V19Z" /></>, 'ForestIcon');
export default ForestIcon